const config = [
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '项目信息',
    },
  },
  {
    component: 'ZlmNormalDetail',
    options: {
      data: {},
    },
  },
  // {
  //     component: 'ZlmTitle',
  //     options: {
  //         size: 'medium',
  //         text: '消息通知内容',
  //     },
  // },
  // {
  //     component: 'ZlmTextBox',
  //     options: {
  //         data: {},
  //     },
  // },
]

const dayjs = require('dayjs').default

const mixin = {
  data() {
    return {
      config: JSON.parse(JSON.stringify(config)),
    }
  },
  methods: {
    getData() {
      this.$request
        .post(
          `/transformToAfter/gt-jy-zhaobiao/api/messageNotice/detail.do`,
          {
            messageGuid: this.$route.query.id,
            isClose: 1,
          },
          { showLoading: true },
        )
        .then((res) => {
            console.log(res)
          this.config[1].options.data = {
            消息通知名称: res.data.messageTitle,
            发布时间: dayjs(res.data.releaseTime).format('YYYY-MM-DD'),
            消息通知内容: '',
          }
          // this.config[3].options.data = {
          //     value: '【临汾市大宁县三多小学教师周转宿舍建设项目施工招标项目】距离开标还有1小时，请您按时参与！',
          //     subInfo: '2020.06.08 14:23',
          // }
        })
    },
  },
}

module.exports = {
  config,
  mixin,
}
